export default "__VITE_ASSET__f8721d3c__"